import { gql } from "@apollo/client"

const DEPARTMENT_FRAGMENTS = {
  departmentsList: gql`
    fragment DepartmentListFrag on DepartmentType {
      id
      name
      updatedAt
      photo
      departmentType
      departmentTypeDisplay
      companies {
        id
        name
      }
      defaultTraderVarieties {
        id
        name
        commodity {
          id
          name
        }
      }
      varieties(first: 15) {
        id
        name
        commodity {
          id
          name
        }
      }
    }
  `,
  departmentDetail: gql`
    fragment DepartmentDetailFrag on DepartmentType {
      id
      name
      photo
      defaultTraderVarieties {
        id
        name
        commodity {
          id
          name
        }
      }
      preferredDepot {
        id
        name
      }
      departmentType
      varieties {
        id
        name
        commodity {
          id
          name
        }
      }
      generatePoPlotWise
      generatePoAfterInward
      controlPricing
      togoSubscription
      qcSubscription
    }
  `,
}
const DEPARTMENT_LIST = gql`
  query allDepartmentsList($first: Int, $query: String, $skip: Int) {
    allDepartments(first: $first, query: $query, skip: $skip) {
      ...DepartmentListFrag
    }
  }
  ${DEPARTMENT_FRAGMENTS.departmentsList}
`

const DEPARTMENT_DETAILS = gql`
  query departmentDetail($id: Int) {
    departmentDetails(departmentId: $id) {
      ...DepartmentDetailFrag
    }
  }
  ${DEPARTMENT_FRAGMENTS.departmentDetail}
`
const ADD_DEPARTMENT = gql`
  mutation addDepartment(
    $controlPricing: Boolean
    $departmentType: String
    $generatePoAfterInward: Boolean
    $generatePoPlotWise: Boolean
    $id: Int
    $name: String
    $photo: String
    $preferredDepot: Int
    $togoSubscription: Boolean
    $varieties: [Int]
    $defaultTraderVarieties: [Int]
    $qcSubscription: Boolean
  ) {
    addUpdateDepartment(
      id: $id
      departmentType: $departmentType
      preferredDepot: $preferredDepot
      name: $name
      varieties: $varieties
      photo: $photo
      controlPricing: $controlPricing
      generatePoAfterInward: $generatePoAfterInward
      generatePoPlotWise: $generatePoPlotWise
      togoSubscription: $togoSubscription
      defaultTraderVarieties: $defaultTraderVarieties
      qcSubscription: $qcSubscription
    ) {
      department {
        ...DepartmentListFrag
        generatePoPlotWise
        generatePoAfterInward
        controlPricing
        togoSubscription
        qcSubscription
      }
    }
  }
  ${DEPARTMENT_FRAGMENTS.departmentsList}
`

const DELETE_DEPARTMENT = gql`
  mutation deleteDepartment($id: Int) {
    delDepartment(departmentId: $id) {
      departmentId
    }
  }
`
export {
  DEPARTMENT_LIST,
  DEPARTMENT_FRAGMENTS,
  ADD_DEPARTMENT,
  DEPARTMENT_DETAILS,
  DELETE_DEPARTMENT,
}
